module.exports = __webpack_public_path__ + "assets/img/30a4-rs.svg";